import { workflowReviewRequestLookupCommandModule } from './workflow-review-request-lookup-command-adapter';
import { InjectionToken } from '@angular/core';
import { WorkflowClientCommandRegistry } from './workflow-command-registry';
import { workflowReviewCommandModule, workflowReviewLookupCommandModule } from './workflow-review-command-adapters';
import { workflowCaptureCommandModule } from './workflow-capture-command-adapter';
import { workflowHearingRescheduleCommandModule } from './workflow-hearing-reschedule-command-adapter';
import { workflowPreparationLookupCommandModule } from './workflow-preparation-lookup-command-adapter';

/** Application composition root. Adding an installed module does not alter the generic staff host. */
export const WORKFLOW_CLIENT_COMMANDS = new InjectionToken<WorkflowClientCommandRegistry>('Installed workflow client commands', {
  providedIn: 'root',
  factory: () => new WorkflowClientCommandRegistry([workflowReviewCommandModule, workflowCaptureCommandModule, workflowHearingRescheduleCommandModule, workflowReviewLookupCommandModule, workflowPreparationLookupCommandModule, workflowReviewRequestLookupCommandModule]),
});
